<template>
  <header
    class="relative flex items-center justify-between flex-shrink-0 w-full mb-8 xl:mb-12 shadow-8 z-header"
  >
    <div class="container relative flex items-center justify-between w-full py-4 bg-white navigation">
      <div>
        <div class="logo" />
      </div>

      <div>
        <div
          v-on-clickaway="closeLanguageSwitcher"
          class="relative lang-switch"
          :class="{ open: showLanguageSwitcher }"
        >
          <div
            class="flex items-center text-lg cursor-pointer trigger"
            @click="toggleLanguageSwitcher"
          >
            <div class="flex-shrink-0 xl:mr-2 w-7 h-7 xl:w-8 xl:h-8">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 311.8 311.8" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="none" d="M0 0h311.8v311.8H0z"/><path fill="none" d="M0 0h311.8v311.8H0z"/><path d="M283.19 152.48A127.46 127.46 0 00159.32 28.61v-.05h-7.08v.05A127.46 127.46 0 0028.38 152.48h-.06v7.08a127.45 127.45 0 00123.92 123.86h7.08a127.45 127.45 0 00123.87-123.86v-7.08zm-57 0a193.93 193.93 0 00-7.09-49.57h36.82a112.59 112.59 0 0113.1 49.57zM164 269.02c-1.55.12-3.11.19-4.68.24v-53h50.08a127.25 127.25 0 01-10 21.87c-9.9 17.01-22.25 27.71-35.4 30.89zm-52-30.94a128.79 128.79 0 01-10-21.87h50.18v53c-1.61 0-3.21-.13-4.81-.25-13.14-3.18-25.48-13.89-35.4-30.93zm35.39-195c1.6-.12 3.21-.2 4.82-.25v53h-50.15a128.79 128.79 0 0110-21.87c9.89-17.04 22.26-27.74 35.36-30.93zm52 30.93a127.25 127.25 0 0110 21.87h-50.07v-53c1.57 0 3.14.13 4.69.24C177.15 46.3 189.5 57 199.43 74.06zm-47.15 28.9v49.57H92.42a185 185 0 017.35-49.57zm0 56.65v49.57H99.77a185 185 0 01-7.35-49.57zm7.08 49.57v-49.57h59.73a185.78 185.78 0 01-7.35 49.57zm0-56.65v-49.57h52.38a185.78 185.78 0 017.35 49.57zm92.49-56.65h-34.93c-7.08-21.19-17.78-38.35-30.65-49a112.62 112.62 0 0149.66 29.07 113.92 113.92 0 0115.92 19.93zM75.67 75.91a112.58 112.58 0 0149.5-29c-12.85 10.65-23.52 27.77-30.59 48.92H59.76a113.4 113.4 0 0115.91-19.92zm-20 27H92.4a194 194 0 00-7.08 49.57H42.55a112.45 112.45 0 0113.1-49.57zm29.65 56.65a194 194 0 007.09 49.57H55.65a112.6 112.6 0 01-13.11-49.57zm-25.56 56.65h34.82c7.07 21.15 17.74 38.35 30.59 48.94a114 114 0 01-65.41-48.94zm176.13 19.92a112.71 112.71 0 01-49.67 29.07c12.87-10.64 23.57-27.8 30.65-49h34.94a114.39 114.39 0 01-15.92 19.92zm20-27h-36.84a193.56 193.56 0 007.09-49.57h42.87a112.58 112.58 0 01-13.09 49.57z"/></svg>
            </div>
            <div class="hidden xl:block">
              {{ $t(`locales.${currentLocale}`) }}
            </div>
          </div>
          <div
            class="absolute top-0 right-0 hidden w-48 px-4 py-1 mt-10 bg-white xl:-mr-4 dropdown shadow-7 xl:mt-12 xl:text-lg"
          >
            <ul>
              <li
                v-for="(locale, i) in availableLocales"
                :key="`Lang${i}`"
                class="py-2 leading-none cursor-pointer"
                @click.prevent="changeLocale(locale)"
              >
                {{ $t(`locales.${locale}`) }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script lang="ts">
import Vue from 'vue'
import { mixin as clickaway } from 'vue-clickaway'

export default Vue.extend({
  mixins: [clickaway],

  data(): {
    showLanguageSwitcher: boolean;
  } {
    return {
      showLanguageSwitcher: false,
    }
  },
  computed: {
    availableLocales(): string[] {
      return this.$i18n.availableLocales.filter((locale) => locale !== this.currentLocale)
    },
    currentLocale(): string {
      return this.$i18n.locale
    },
  },

  /*
  mounted() {
    window.onbeforeunload = (event: Event) => {
      // TODO: every window.location or a href with outside link needs
      // to skip the code below in order to prevent the popup.
      // (since this is a wanted redirection compared to a page refresh or page close)
      // This can be done, so that for every link we dispatch an action,
      // that sets a state before actually doing the redirect.
      // Then in this function, if that variable is set to true
      // don't show a popup warning on leave.
      // event.preventDefault() // per the standard
      // event.returnValue = '' // required for Chrome
    }
  },
  */

  methods: {
    toggleLanguageSwitcher() {
      this.showLanguageSwitcher = !this.showLanguageSwitcher
    },
    closeLanguageSwitcher() {
      this.showLanguageSwitcher = false
    },
    changeLocale(locale: string) {
      this.$store.dispatch('locale/set', { locale })
    },
  },
})
</script>

<style lang="scss" scoped>
.navigation {
  height: 60px;
}

.logo {
  width: 129px;
  height: 30px;
  background: url('~images/psp/swiss/logo/logo-primary.svg') 0 0 / 129px 30px no-repeat;
}

.lang-switch {
  .dropdown {
    &::before {
      content: "";
      position: absolute;
      right: 9px;
      top: -5px;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 6px 5px 6px;
      border-color: transparent transparent #FFFFFF transparent;

    }

    &::after {
      position: absolute;
      right: 9px;
      top: 0;
      width: 30px;
      height: 8px;
      content: '';
      background: white;
    }
  }

  &.open {
    .dropdown {
      @apply block;
    }
  }
}

@screen xl {
  .navigation {
    height: 90px;
  }

  .logo {
    width: 185px;
    height: 43px;
    background-size: 185px 43px;
  }

  .lang-switch {
    .dropdown {
      &::before {
        right: 16px;
      }

      &::after {
        right: 16px;
      }
    }
  }
}
</style>
